<nb-select fullWidth
           [placeholder]="placeholder"
           [(selected)]="value"
           [disabled]="isDisabled">
  <nb-option *ngFor="let v of values" [value]="v">{{v | dimensionTranslation}}</nb-option>
</nb-select>
